import React, { FC, useContext } from "react";
import Avatar from "@material-ui/core/Avatar";
// import { useAuthUser } from "../../utility/AppHooks";
import { useHPUser } from "../../utility/AppHooks";
import { Link, makeStyles } from "@material-ui/core";
// import MenuItem from "@material-ui/core/MenuItem";
// import Menu from "@material-ui/core/Menu";
import Box from "@material-ui/core/Box";
import { orange } from "@material-ui/core/colors";
import { Fonts } from "../../../shared/constants/AppEnums";
// import Hidden from "@material-ui/core/Hidden";
// import { setAuthToken } from "../../services/ApiConfig";
import AppContextPropsType from "../../../types/AppContextPropsType";
import AppContext from "../../utility/AppContext";
import { Menu, Link as MuiLink, MenuItem, useTheme, Icon, SxProps, IconProps, Box as MuiBox } from "@mui/material"
import { useIntlMesssages } from "@crema/utility/LocaleProvider";
import { MdLogout, MdSettings } from "react-icons/md";
import { FaNetworkWired } from "react-icons/fa";
import { useBreakPointDown } from "@crema/utility/Utils";

const useStyles = makeStyles(theme => {
  return {
    // userRoot: {
    //   display: 'flex',
    //   alignItems: 'center',
    //   cursor: 'pointer',
    //   justifyContent: 'center',
    // },
    avatar: {
      fontSize: 24,
      backgroundColor: orange[500],
    },
    userInfo: {
      width: 'calc(100% - 75px)',
    },
    pointer: {
      cursor: 'pointer',
    },
    userName: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      cursor: 'pointer',
      whiteSpace: 'nowrap',
      fontSize: 15,
      fontWeight: Fonts.MEDIUM,
      color: (props: {bgType: string}) =>
        props.bgType === 'colored' ? 'white' : theme.palette.text.primary,
    },
  };
});

interface HorUserInfoProps {
  bgType?: string;
}

const HorUserInfo: FC<HorUserInfoProps> = ({bgType = 'colored'}) => {
  const { setHPUser } = useContext<AppContextPropsType>(AppContext);
  const mdDown = useBreakPointDown('md');

  const messages = useIntlMesssages();
  const MuiTheme = useTheme();
  // const user = useAuthUser();
  const user = useHPUser();
  const userDisplayName = user?.nome + " " +user?.cognome;

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const onUserSignout = () => {
    //logout API goes Here
    // updateAuthUser(null);
    // setAuthToken(null);
    setHPUser(null);
  };
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget.parentElement);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  // const getUserAvatar = () => {
  //   if (user && user.displayName) {
  //     return user.displayName.charAt(0).toUpperCase();
  //   }
  //   if (user && user.email) {
  //     return user.email.charAt(0).toUpperCase();
  //   }
  // };
  const getUserAvatar = () => {
    if (user && userDisplayName) {
      return userDisplayName.charAt(0).toUpperCase();
    }
    if (user && user.email) {
      return user.email.charAt(0).toUpperCase();
    }
  };
  const classes = useStyles({bgType});

  return (
    <MuiBox py='8px' alignSelf='stretch'
      pl={{xs: '8px', sm: '12px', md: '20px'}}
      alignItems='center' display='flex'
    >
      <MuiBox display='flex' onClick={handleClick}
        alignItems='center'
        justifyContent='center'
        sx={{
          cursor: 'pointer',
          p: '6px',
          borderRadius: mdDown ? '50%' : '8px',
          margin: '-6px',

          border: '1px solid',
          bgcolor: anchorEl ? 'rgba(0,0,0,0.2)' : undefined,
          '&:hover': {
            bgcolor: 'rgba(236, 236, 236, 0.9)',
            // borderColor: 'rgba(0, 0, 0, 0.25)',
          }
        }}
      >
        {/* {user && user.photoURL ? (
          <Avatar className={classes.avatar} src={user.photoURL} />
        ) : ( */}
          <Avatar className={classes.avatar}>{getUserAvatar()}</Avatar>
        {/* )} */}
        {/* <Hidden mdDown> */}
        {
          !mdDown &&
          <Box ml={3} className={classes.userName}
            mr='10px'
          >
            {/* {user && (user.displayName ? user.displayName : user.email)} */}
            {user && (userDisplayName || '')}
            {/* <Box fontSize={13} fontWeight={Fonts.LIGHT}>
              System Manager
            </Box> */}
          </Box>
        }
        {/* </Hidden> */}
      </MuiBox>
      <Menu
        id='simple-menu'
        anchorEl={anchorEl}
        keepMounted
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {/* <MenuItem>My account</MenuItem>
        <MenuItem onClick={onUserSignout}>
          Logout
        </MenuItem> */}
        {/* <MuiLink underline="none" color={MuiTheme.palette.text.primary} href="/Profilo">
          <MenuItem onClick={()=>{}} sx={commonListItemStyle}>
            <Icon fontSize="small"
              {...commonIconProps}
            >
              <MdSettings />
            </Icon>
            {messages['_hp.myProfile.sidebarLabel']}
          </MenuItem>
        </MuiLink> */}

        <Link underline="none" style={{color: MuiTheme.palette.text.primary}} href={process.env.REACT_APP_KOALY_INTRANET_URL} target="_blank" rel='noreferrer'>
          <MenuItem
            sx={commonListItemStyle}
            onClick={()=>{}}
          >
            <Icon fontSize="small"
              {...commonIconProps}
            >
              <FaNetworkWired />
            </Icon>
            {messages['_hp.intranet.sidebarLabel']}
          </MenuItem>
        </Link>

        <MenuItem
          onClick={() => {
            onUserSignout()
          }}
          sx={{
            ...commonListItemStyle,
            color: MuiTheme.palette.text.primary
          }}
        >
          <Icon fontSize="small"
            {...commonIconProps}
            color="error"
          >
            <MdLogout />
          </Icon>
          {messages['_hp.general.logout']}
        </MenuItem>
      </Menu>
      {/* <Box className={classes.userInfo} pr='16px' pl='10px'>
      </Box> */}
    </MuiBox>
  );
};

export default HorUserInfo;

const commonListItemStyle: SxProps = {
  pr: '12px',
  pl: '10px'
}

const commonIconProps: IconProps = {
  sx: {
    mr: '8px',
  },
  color: 'primary'
}